import React from "react";
import { IconFlagFilled } from "@tabler/icons-react";

// Shared "Red Flags" mark — a filled Tabler flag in danger red. Used wherever the chief-complaint
// red-flag rubric is shown (Case Library group headers, Run detail, Runs & Storage results).
export default function RedFlag({ size = 13, style }) {
  return <IconFlagFilled size={size} style={{ color: "var(--bad, #c0392b)", verticalAlign: "-2px", ...style }} />;
}
